// Copyright (c) 2023 Deere & Company

import './index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import {
    filterCollection,
     sortCollection
 } from '../../../../shared/services/collections';
import Accordion from '../../../../shared/components/accordion';
import DuplicatePinPlate from '@deere/cps-it.warranty-model-factory/lib/duplicate-pin-plate';
import DuplicatePinPlateFilterOptions from '../../services/duplicate-pin-plate-filter-options';
import DuplicatePinPlateList from './duplicate-pin-plate-list';
import {FormattedMessage} from 'react-intl';
import SearchFilters from '../../../../shared/state/search-filters';
import {buildNumber} from '../../../../shared/services/build-number';

function handleFilterByChange(filterBy) {

    this.actions.updateDuplicatePinPlateListFilterBy(filterBy);

}

function handleSortByChange(sortBy) {

    this.actions.updateDuplicatePinPlateListSortBy(sortBy);

}

function handleSortDirectionChange(sortDirection) {

    this.actions.updateDuplicatePinPlateListSortDirection(sortDirection);

}

class DuplicatePinPlateAccordion extends Component {

    render() {

        let sortedCollection;

        sortedCollection = [...this.props.duplicatePinPlateChanges];

        sortedCollection = sortCollection(this.props.duplicatePinPlateSearchFilters.sortBy, this.props.duplicatePinPlateSearchFilters.sortDirection, sortedCollection);
        sortedCollection = filterCollection(this.props.duplicatePinPlateSearchFilters.filterBy, DuplicatePinPlateFilterOptions, sortedCollection);
        const sortedCollectionLength = sortedCollection && sortedCollection.length;

        const title = (
            <FormattedMessage
                id='DUPLICATE_PIN_PLATE_WITH_COUNT'

                values={{
                    count: buildNumber(sortedCollectionLength)
                }}

            />
        );

        const body = (
            <DuplicatePinPlateList
                actions={this.props.actions}
                duplicatePinPlateChanges={sortedCollection}
                duplicatePinPlateSearchFilters={this.props.duplicatePinPlateSearchFilters}
                selectedDealers={this.props.selectedDealers}
                updateListFilterBy={this.props::handleFilterByChange}
                updateListSortBy={this.props::handleSortByChange}
                updateListSortDirection={this.props::handleSortDirectionChange}
            />
         );

        return (

            this.props.duplicatePinPlateChanges.length > 0 &&
            <Accordion
                accordionId='duplicate-pin-plate-accordion'
                body={body}
                title={title}
            />

        );

    }

}

DuplicatePinPlateAccordion.displayName = 'DuplicatePinPlateAccordion';
DuplicatePinPlateAccordion.propTypes = {
    actions: PropTypes.object.isRequired,
    duplicatePinPlateChanges: PropTypes.arrayOf(PropTypes.instanceOf(DuplicatePinPlate)).isRequired,
    duplicatePinPlateSearchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    isModalVisible: PropTypes.bool,
    length: PropTypes.number.isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(String))
};

export default DuplicatePinPlateAccordion;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/duplicate-pin-plate/duplicate-pin-plate-accordion.js